<template>
    <div>
        <div class="widget-title">
            <info-title class="d-inline-block">
                {{title}}
            </info-title>
            
            <info-sub-title v-if="subTitle">
                {{subTitle}}
            </info-sub-title>

            <help-popover v-if="tooltip" :content="tooltip" class="d-inline-block" />
            
            <br />
            
            <copy-id-button :id="id" />
        </div>
        
        <div class="widget-content">
            <template v-if="widgetComponent && widgetData">
                <component
                    v-if="widgetData.data.length !== 0"
                    
                    :is="widgetComponent"
                    :configuration="configuration"
                    :data="widgetData"
                />
                <template v-else>{{resource('Chart_ErrorMessage_NoData')}}</template>
            </template>
            <loader v-else />
        </div>
    </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";
import {debounceWithLeadingCallAsync} from "@modules/JourneyBuilder/Components/Charts/SankeyV2/helpers";

import resourceMixin from "@core/Util/Mixins/resources";

import InfoTitle from "./InfoTitle";
import InfoSubTitle from "./InfoSubTitle";
import Loader from "@modules/JourneyBuilder/Components/Elements/Loader";
import {CopyIdButton, HelpPopover} from "@modules/JourneyBuilder/Components/Elements";

import componentTypeBinding from './widget-component-type-binding';

const {mapState, mapGetters} = createNamespacedHelpers('journeyBuilder/reporting');

export default {
    name: "Widget",
    mixins: [resourceMixin],
    components: {
        CopyIdButton,
        HelpPopover,
        InfoTitle,
        InfoSubTitle,
        Loader
    },
    async created() {
        this.loadData = debounceWithLeadingCallAsync(this.loadData).bind(this);
        
        await this.loadData();
        
        //We want to react not only to parameter changes; but also to brickId changes
        this.$watch(
            () => `${this.brickId}|${this.watchableReportStatisticsParameters}`, 
            () => this.loadData()
        );
    },
    methods: {
        async loadData(){
            try {
                this.widgetData = null;
                
                this.widgetData = await api.getReportStatisticsWidgetData(
                    this.journeyId,
                    this.brickId,
                    this.configuration.id,
                    this.reportStatisticsParameters
                )
            }catch(e){
                bootstrapDangerGrowl(e);
            }
        }
    },
    computed: {
        ...mapState(['journeyId']),
        ...mapGetters(['watchableReportStatisticsParameters', 'reportStatisticsParameters']),

        id(){
            return this.configuration.id;
        },
        title(){
            return this.configuration.title;
        },
        subTitle(){
            return this.configuration.subTitle;
        },
        tooltip(){
            return this.configuration.tooltip;
        },
        widgetComponent(){
            return componentTypeBinding[this.configuration.type];
        }
    },
    props: {
        /**
         * @type {SankeyTouchpointInfoConfigWidget}
         */
        configuration: {
            type: Object,
            required: true
        },
        brickId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            widgetData: null
        }
    }
}
</script>
